import { Ratio } from '../../cms/enums/ratio'
import { ImageUrlRatios } from '../../cms/components/types'

export class ImageUtils {

  static getImageRatioParameters (ratio: Ratio): ImageUrlRatios | undefined {
    switch (ratio) {
      case Ratio.RATIO_1_1:
        return {
          xl: '-S1920x1920',
          lg: '-S1200x1200',
          md: '-S992x992',
          sm: '-S768x768',
          xs: '-S500x500',
          xl2x: '-S3840x3840',
          lg2x: '-S2400x2400',
          md2x: '-S1984x1984',
          sm2x: '-S1536x1536',
          xs2x: '-S1000x1000',
        }
      case Ratio.RATIO_2_1:
        return {
          xl: '-S1920x960',
          lg: '-S1200x600',
          md: '-S992x496',
          sm: '-S768x384',
          xs: '-S500x250',
          xl2x: '-S3840x1920',
          lg2x: '-S2400x1200',
          md2x: '-S1984x992',
          sm2x: '-S1536x768',
          xs2x: '-S1000x500',
        }
      case Ratio.RATIO_4_1:
        return {
          xl: '-S1920x480',
          lg: '-S1200x300',
          md: '-S992x248',
          sm: '-S768x192',
          xs: '-S500x125',
          xl2x: '-S3840x960',
          lg2x: '-S2400x600',
          md2x: '-S1984x496',
          sm2x: '-S1536x384',
          xs2x: '-S1000x250',
        }
      case Ratio.RATIO_10_1:
        return {
          xl: '-S1920x192',
          lg: '-S1200x120',
          md: '-S992x99',
          sm: '-S768x77',
          xs: '-S500x50',
          xl2x: '-S3840x384',
          lg2x: '-S2400x240',
          md2x: '-S1984x198',
          sm2x: '-S1536x154',
          xs2x: '-S1000x100',
        }
      default:
        return undefined
    }
  }

  static getRatioByString (ratio: string): Ratio {
    switch (ratio) {
      case '1_1':
        return Ratio.RATIO_1_1
      case '2_1':
        return Ratio.RATIO_2_1
      case '4_1':
        return Ratio.RATIO_4_1
      case '10_1':
        return Ratio.RATIO_10_1
      default:
        return Ratio.RATIO_1_1
    }
  }
}
